/*
 * @Description:排序-分组公共方法
 * @Version: 2.0
 * @Autor: 纪楠楠 jinannan@qfei.cn
 * @Date: 2025-06-06
 * @LastEditors: 纪楠楠 jinannan@qfei.cn
 */
export default function useSortGroup() {
  // 处理禁用状态
  const handleOptionsDisabled = (data, options) => {
    console.log('handleOptionsDisabled-hooks', data, options);
    // 整理参与排序的字段
    const sortingFields = data?.filter((field) => field.fieldKey)?.map((el) => el.fieldKey?.split('-')?.[0]) || [];
    options?.forEach((item) => {
      if (sortingFields?.includes(item.copyFieldKey)) {
        item.disabled = true;
      } else {
        item.disabled = false;
      }
    });
  };
  // 处理特殊标识  type 9:日期范围 10:级联选择器
  const fieldChange = (data, options, fieldType) => {
    data?.forEach((item) => {
      const _str = item.fieldKey?.split('-');
      const _obj = options.find((sub) => sub.fieldKey == item.fieldKey);
      //2025年06月27日13:48:27 zl 兼容_obj为null，用户选择多个，只选择一个，其他的就为null
      if (_obj?.fieldType == fieldType) {
        if (_obj?.fieldKey == item?.fieldKey) {
          item.subProperty = _str[1];
        }
      } else {
        item.subProperty = '';
      }
    });
    handleOptionsDisabled(data, options);
  };
  return {
    fieldChange,
    handleOptionsDisabled
  };
}
